import { Video } from "../globe_header/video";

export class BeforeAfterHeader {
  constructor() {
    this.beforeAfterHeaderWrapper = document.querySelector('.js-before-after-header')

    if (!this.beforeAfterHeaderWrapper) { return false}

    this.video = new Video(false)
  }
}
